import React, { useState, useEffect } from "react";
import {
  Modal,
  Box,
  Typography,
  TextField,
  Button,
  Snackbar,
  Alert,
} from "@mui/material";
import emailjs from "emailjs-com";
import { xorDecrypt } from "../encrypt";

const EmailModal = ({ open, handleClose }) => {
  const [email, setEmail] = useState("");
  const [content, setContent] = useState("");
  const [name, setName] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  useEffect(() => {
    const storedEmail = xorDecrypt(localStorage.getItem("username"));
    if (storedEmail) {
      setEmail(storedEmail);
    }
  }, []);

  const handleSubmit = async () => {
    const templateParams = {
      to_email: email,
      content: content,
      from_name: name,
      to_name: "InSightSoftGen",
    };

    try {
      await emailjs.send(
        "service_3qs6jxi",
        "template_z6fhwsh",
        templateParams,
        "4iu5dii7kiZCOwSLq"
      );
      setSnackbarOpen(true);
      handleClose();
    } catch (error) {
      console.error("Error sending email:", error);
    }
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  return (
    <>
      <Modal open={open} onClose={handleClose}>
        <Box sx={{ ...modalStyle }}>
          <Typography variant="h4" component="h2" gutterBottom>
            Contact Us
          </Typography>
          <Typography variant="h6" component="h3">
            Send an email to InSightSoftGen
          </Typography>
          <Box component="form" onSubmit={(e) => e.preventDefault()}>
            <TextField
              fullWidth
              label="Your Email"
              variant="outlined"
              margin="normal"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled
            />
            <TextField
              fullWidth
              label="Your Name"
              variant="outlined"
              margin="normal"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
            <TextField
              fullWidth
              label="Content"
              variant="outlined"
              margin="normal"
              value={content}
              onChange={(e) => setContent(e.target.value)}
              required
              multiline
              rows={4}
            />
            <Button variant="contained" color="primary" onClick={handleSubmit}>
              Send
            </Button>
          </Box>
        </Box>
      </Modal>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
      >
        <Alert onClose={handleSnackbarClose} severity="success">
          Email sent successfully!
        </Alert>
      </Snackbar>
    </>
  );
};

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

export default EmailModal;
